import React, { useCallback } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// HOOKS
import { useLogContext } from '../helpers/logContext';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// STYLES
import styles from './closeButton.module.scss';
import logStyles from '../logs.module.scss';

// MAIN COMPONENT
const CloseButton = ({
  className
}) => {

  // HOOKS
  const { setActiveLog } = useLogContext();

  // CALLBACKS
  const handleClick = useCallback(
    () => setActiveLog(undefined),
    [setActiveLog]
  )

  // RENDER
  return (
    <Button
      className={clsx(
        styles.closeButton,
        logStyles.closeButton,
        className
      )}
      variant="custom"
      icon={{
        className: styles.icon,
        use: 'cancel'
      }}
      onClick={handleClick}
    />
  );
}

// EXPORT
export default CloseButton;
